{
    "common": {
        "skipLink": {
            "skipTo": "Přejít na",
            "labels": {
                "header": "Záhlaví",
                "main": "Hlavní obsah",
                "footer": "Zápatí",
                "productFacets": "Filtrování produktů",
                "productList": "Seznam produktů"
            }
        },
        "common": {
            "cancel": "Zrušit",
            "back": "Zpět",
            "reset": "Resetovat",
            "search": "Hledat",
            "remove": "Odstranit",
            "home": "Domů",
            "contacts": {
                "openingHours": "(Po-Pá 8:00 - 15:30)",
                "sikob2bspacz": {
                    "phone": "+420 222 300 666",
                    "email": "velkoobchod@siko.cz",
                    "helplineAvailibility": "(Po-Pá 8:00 - 15:30)"
                },
                "sikob2bspask": {
                    "phone": "+421 222 300 666",
                    "email": "velkoobchod@siko.sk",
                    "helplineAvailibility": "(Po-Pá 8:00 - 15:30)"
                },
                "sikob2bspaeu": {
                    "phone": "+420 222 300 666",
                    "email": "info@b2b.siko.eu",
                    "helplineAvailibility": "(Po-Pá 8:00 - 15:30)"
                }
            }
        },
        "formErrors": {
            "labeled": {
              "email": "Neplatný formát e-mailu",
              "sikoWrongValueDiscount": "Hodnota slevy mimo povolený rozsah.",
                "sikoInvalidTotalPrice": "Objednávku nebylo možné odeslat z důvodu nízké hodnoty.",
                "sikoTermsAndConditions": "Souhlas s obchodními podmínkami je povinný.",
                "sikoPreferredPickupDateWeekendDisable": "Vyzvednutí o víkendu není možný",
                "sikoPreferredPickupDateHigherThanMax": "Zadejte datum max. 2 měsíce v budoucnosti.",
                "sikoPreferredPickupDateLowerThanToday": "Zadaný datum nesmí být nižší než aktuální datum.",
                "sikoRequiredDate": "Nesprávné nebo chybějící datum.",
                "sikoCheckoutNote": "Překročili jste povolenou délku 255 znaků",
                "sikoPoNumber": "Překročili jste povolenou délku 35 znaků",
                "required": "Povinné",
                "pattern": "Zadejte správný formát",
                "cxInvalidPassword": "Heslo nesplňuje požadavky. (Nejméně 8 znaků, včetně 1 písmena a 1 čísla)",
                "cxInvalidOldPassword": "Zadejte své aktuální heslo",
                "cxPasswordsMustMatch": "Heslá se musí shodovat",
                "cxInvalidEmail": "Toto není platný formát e-mailu",
                "cxEmailsMustMatch": "E-mailove adresy se musí shodovat",
                "maxlength": "Zadaný údaj přesahuje maximální délku ",
                "sikoPhoneFormat": "Zadejte správný formát pro telefon",
                "sikoVat": "Zadejte správný formát pro DIČ",
                "sikoTaxId": "Zadejte správný formát pro IČ DPH",
                "sikoPostCode": "Zadejte správný formát pro PSČ",
                "sikoPassword": "Neplatný formát hesla (Zadejte nejméně 8 znaků, včetně 1 písmena a 1 čísla)",
                "sikoFullNameLength": "Položky (Jméno, Příjmení) přesahují maximální délku (40)",
                "sikoCompanyName": "Zadaný údaj přesahuje maximální délku (40)",
                "sikoPin": "Zadejte 6 místný číselný kód PIN, který Vám byl doručen prostřednictvím e-mailu nebo SMS zprávy",
                "matDatepickerParse": "Zadejte validní datum ve formátu dd.mm.rrrr",
                "matDatepickerFilter": "Zadejte validní datum ve formátu DD.MM.RRRR",
                "matDatepickerMin": "Zadejte validní rozsah datum.",
                "sikoInvalidCode": "Zadaný kód kupónu není platný.",
                "sikoPositiveNumber": "Zadejte kladné číslo",
                "emailNotAllowed": "Neplatné uživatelské jméno",
                "file": {
                    "notParsable": "Soubor nelze načíst",
                    "tooManyEntries": "Počet položek je větší než {{ maxEntries }}",
                    "empty": "Soubor nesmí být prázdný",
                    "invalidExtension": "Nepodporovaný formát souboru",
                    "tooLarge": "Velikost souboru nesmí překročit {{ maxSize }} MB"
                }
            }
        },
        "customLoginPage": {
            "badRequest": {
               "bad_credentials": "<strong>Neplatné přihlašovací údaje. Prosím, přihlaste se znovu.</strong><br><br>Pokud jste si jisti, že zadáváte správné heslo, může být z důvodu aktualizace systému nutné obnovit heslo pomocí možnosti <strong>„Zapomenuté heslo“</strong>.",
               "account_disabled": "Uživatel je deaktivován. Prosím, kontaktujte administraci.",
               "unknown_error": "Došlo k neznámé chybě. Prosím, zkuste to znovu později.",
               "missing_id": "Přihlášení nebylo úspěšné. Prosím, počkejte na potvrzovací e-mail.",
               "missing_store": "Přihlášení nebylo úspěšné. Prosím, kontaktujte zákaznické centrum pro vyřešení.",
               "wrong_basestore": "Přihlášení nebylo úspěšné. Prosím, zkontrolujte si správnost zadané URL adresy dle Vaší registrace."
            }
         },
        "httpHandlers": {
            "SikoCartPaymentMinValueError": "Příliš nízká hodnota objednávky. Zvolte prosím jiný způsob platby.",
            "maintenanceError": "Tato služba je dočasně nedostupná z důvodu údržby.",
            "loginRequire": "Před narokováním kupónu se prosím přihlaste.",
            "userUidNotFound": "Nelze najít uživatele s UID: {{ uid }}",
            "cartNotFound": "Košík nenalezen. Obnovte prosím stránku.",
            "invalidCodeProvided": "Byl zadán neplatný kód.",
            "badRequestOldPasswordIncorrect": "Staré heslo je nesprávné.",
            "badRequest": {
                "bad_credentials": "Nesprávné přihlašovací údaje. Prosím zkuste to znovu.",
                "user_is_disabled": "Uživatel je zakázán. Kontaktujte prosím administraci.",
                "password_expired": "{{ errorMessage }}. Prosím změňte své heslo."
            },
            "sessionExpired": "Vaše relace vypršela. Přihlaste se prosím znovu.",
            "authenticationErrors": {
                "badRequest": "Přihlášení nebylo úspěšné. Prosím zkuste to znovu.",
                "wrongUserModel": "Do ASM se může přihlásit pouze zaměstnanec.",
                "asmAgentMissingRoles": "Agentu ASM chybí potřebná oprávnění"
            },
            "forbidden": "K provedení této akce nemáte oprávnění. Pokud se domníváte, že se jedná o chybu, kontaktujte svého správce.",
            "timeout": "Není možné zobrazit obsah pro zadané období. Zkuste zmenšit vyhledávané období.",
            "badGateway": "Došlo k chybě serveru. Prosím zkuste to znovu později.",
            "gatewayTimeout": "Server neodpověděl, zkuste to znovu později.",
            "validationErrors": {
                "missing": {
                    "deliveryAddressStreetNumber": "Neplatné číslo ulice doručení",
                    "deliveryAddress": {
                        "countryIso": "Neplatný kód země společnosti",
                        "postcode": "Neplatné PSČ společnosti"
                    },
                    "email": "Neplatný email",
                    "phonePrefix": "Neplatná mobilní předvolba"
                },
                "invalid": {
                    "password": "Zadané heslo není platné.",
                    "companyId": "Neplatné ID společnosti",
                    "companyVatId": "Neplatné DIČ společnosti",
                    "legalFormType": "Neplatný typ právní formy",
                    "companyName": "Neplatný název společnosti",
                    "companyAddressCity": "Neplatný název města společnosti",
                    "companyAddressPostalCode": "Neplatné poštovní směrovací číslo",
                    "companyAddressStreet": "Neplatný název ulice společnosti",
                    "companyAddressStreetNumber": "Neplatné číslo ulice společnosti",
                    "companyAddressCountryIso": "Neplatný kód země společnosti",
                    "deliveryAddressStreetNumber": "Neplatné dodací číslo",
                    "phone": "Neplatné telefonní číslo",
                    "email": "Neplatný e-mail",
                    "phonePrefix": "Neplatna mobilní předvolba",
                    "contactPerson": {
                        "firstName": "Neplatné křestní jméno",
                        "lastName": "Neplatné příjmení",
                        "email": "Neplatný e-mail",
                        "pwd": "Neplatné heslo",
                        "checkPwd": "Neplatné heslo",
                        "consentForm": {
                            "phone": "Neplatné telefonní číslo"
                        }
                    },
                    "deliveryAddres": {
                        "townCity": "Neplatné město doručení",
                        "line1": "Neplatný název dodací ulice",
                        "postcode": "Neplatné poštovní směrovací číslo zásilky"
                    },
                    "couponAssignResult": {
                        "ASSIGNED": "Tento zákaznický kupón jste si již nárokovali.",
                        "INEXISTENCE": "Tento zákaznický kupón neexistuje.",
                        "INCORRECTPROMOGROUP": "Tento zákaznický kupón je neplatný."
                    }
                }
            },
            "sikoTicketMaxUploadSize": "Součet velikosti souborů může být maximálně {{ maxSize }} MB",
            "sikoTicketMaxCountOfFiles": "Maximální počet obrázků je 10",
            "notFound": {
                "product": "Produkt nebyl nalezen",
                "category": "Kategorie nebyla nalezena"
            },
            "cart": {
                "noRestoredEntries": "Žádné položky košíku nebyly obnoveny.",
                "reloadCartRequired": "Nastala změna v košíku. Obnovte prosím stránku.",
                "changePartialDeliveryFailed": "Nastavení částečného dodání nebylo úspěšné"
            },
            "product": {
                "reviewPostForbidden": "Recenzi je možné napsat pouze k produktům, které jste u nás zakoupili."
            }
        },
        "navigation": {
        "categoryNavLabel": "Nabídka Kategorie",
        "footerNavLabel": "Odkazy v zápatí",
        "goTo": "Přejít na {{location}}",
        "navigateTo": "Navigovat k {{nav}}",
        "scrollToTop": "Vraťte se na začátek stránky.",
        "linkItemInList": "{{title}}. {{position}} z {{listLength}}",
        "menuButonTitle": "{{title}} Menu"
      },
        "miniCart": {
          "item": "{{count}} položka aktuálně ve vašem košíku",
          "item_other": "{{count}} položek aktuálně ve vašem košíku",
          "total": "{{total}}",
          "count": "{{count}}"
        },
        "pageMetaResolver": {
            "category": {
                "title": "{{count}} výsledek pro {{query}}",
                "title_other": "Počet výsledků pro {{query}}: {{count}}"
            },
            "checkout": {
                "title": "Pokladna"
            },
            "search": {
                "title": "{{count}} výsledek pro „{{query}}“",
                "title_other": "Počet výsledků pro „{{query}}“: {{count}}",
                "findProductTitle": "{{count}} výsledek pro kupón „{{coupon}}“",
                "findProductTitle_other": "Počet výsledků pro kupón „{{coupon}}“: {{count}}",
                "default_title": "Všechny produkty"
            },
            "product": {
                "description": "{{description}}",
                "heading": "{{heading}}",
                "title": "{{title}}"
            }
        }
    },
    "organization": {
        "orgUnit": {
            "header": "Obchodní jednotky",
            "uid": "ID obchodní jednotky",
            "name": "Název obchodní jednotky",
            "assignedPos": "Prodejní kancelář",
            "assignedWorker": "Zodpovědný pracovník SIKO",
            "state": "Stav"
        },
        "orgUser": {
            "active": "Status",
            "name": "Uživatel",
            "unit": "Obchodní jednotka",
            "sort": {
                "byName": "Jména",
                "byUnit": "Jednotky"
            }
        },
        "organization": {
            "enabled": "Aktivní",
            "disabled": "Zakázán",
            "httpHandlers": {
                "conflict": {
                    "user": "Uživatel s e-mailem {{code}} již existuje."
                }
            },
            "notification": {
                "noSufficientPermissions": "Pro přístup k této stránce nemáte dostatečná oprávnění"
            }
        }
    },
    "checkout": {
        "checkout": {
            "invalid": {
                "accountType": "Chcete-li provést nákup, musíte mít roli zákazníka."
            }
        }
    },
    "checkoutB2B": {
        "checkoutB2B": {
            "invalid": {
                "accountType": "Chcete-li provést nákup, musíte mít roli zákazníka."
            }
        }
    },
    "configuration": {
        "configuration": {
            "configure": "Konfigurovat"
        }
    },
    "product": {
        "itemCounter": {
            "removeOne": "Odebrat jeden",
            "addOneMore": "Přidat ještě jeden",
            "quantity": "Množství"
        },
        "product": {
            "productPageTitle": "{{title}} | SIKO B2B"
        },
        "addToCart": {
            "addToCart": "Přidat do košíku"
        },
        "productReview": {
            "thankYouForReview": "Děkujeme za Vaši recenzi."
        },
        "TabPanelContainer": {
            "tabs": {
                "ProductDetailsTabComponent": "Detail produktu",
                "ProductReviewsTabComponent": "Hodnocení",
                "ProductDocumentsTabComponent": "Dokumenty"
            }
        }
    },
    "myAccount": {
        "updateProfileForm": {
            "customerId": "E-mailová adresa",
            "firstName": {
                "label": "Jméno"
            },
            "lastName": {
                "label": "Příjmení"
            },
            "profileUpdateSuccess": "Osobní údaje byly úspěšně aktualizovány"
        },
        "myCoupons": {
            "claimCustomerCoupon": "Úspešne ste si nárokovali tento kupón."
        }
    },
    "userAccount": {
        "loginForm": {
            "forgotPassword": "Zapomněli jste své heslo?",
            "signIn": "Chci se přihlásit",
            "register": "Registrovat",
            "dontHaveAccount": "Nemáte účet?",
            "emailAddress": {
                "label": "E-mail",
                "placeholder": "E-mail"
            },
            "password": {
                "label": "Heslo",
                "placeholder": "Heslo"
            },
            "wrongEmailFormat": "Toto není platný formát e-mailu.",
            "logIn": "Přihlaste se"
        },
        "miniLogin": {
            "userGreeting": "Dobrý den, {{name}}",
            "signInRegister": "Přihlásit se / Registrovat",
            "signIn": "Přihlásit se",
            "myAccount": "Můj účet"
        }
    },
    "productListingPage": {
        "productListingPage": {
            "plpPageTitle": "{{title}} | SIKO B2B",
            "searchResultPageTitle": "Vyhledávání {{query}} | SIKO B2B"
        }
    },
    "storeFinder": {
        "storeFinder": {
            "noStoresFound": "Žádná prodejna nebyla nalezena...",
            "geolocationNotEnabled": "Nelze najít obchody v okolí. Souhlas s geolokací nebyl udělen"
        }
    },
    "address": {
        "addressForm": {
            "title": "Oslovení",
            "defaultTitle": "Titul",
            "companyName": "Jméno firmy (volitelné)",
            "firstName": {
                "label": "Jméno",
                "placeholder": " Jméno"
            },
            "lastName": {
                "label": "Příjmení",
                "placeholder": "Příjmení"
            },
            "address1": "Ulice",
            "address2": "Popisné číslo",
            "country": "Země",
            "city": {
                "label": "Město",
                "placeholder": "Město"
            },
            "state": "Okres",
            "zipCode": {
                "label": "PSČ",
                "placeholder": "PSČ"
            },
            "phoneNumber": {
                "label": "Telefonní číslo",
                "placeholder": "(555) 555 - 0123"
            },
            "email": {
                "label": "E-mail"
            }
        }
    },
    "importExport": {
        "exportEntries": {
            "columnNames": {
                "name": "Název",
                "code": "Kód",
                "package": "Měrná jednotka",
                "retailPrice": "MO cena s DPH",
                "discount": "Sleva ze SIKO ceny",
                "customerPrice": "VO cena bez DPH",
                "totalPrice": "Cena celkem s DPH",
                "unit": "Jednotka",
                "url": "Odkaz",
                "quantity": "Množství"
            }
        }
    },
    "cart": {
        "cartItems" : {
          "itemRemoved": "Vybraná položka byla odstraněna. Celková částka košíku byla aktualizována."
        },
        "validation": {
            "cartEntriesChangeDuringCheckout": "Při zpracování objednávky jsme zjistili problémy s vašimi položkami. Zkontrolujte prosím svůj košík.",
            "cartEntryRemoved": "{{name}} byl vyřazen z košíku z důvodu nedostupnosti.",
            "productOutOfStock": "{{name}} byl odstraněn z košíku z důvodu nedostatku zásob.",
            "lowStock": "Množství se snížilo na {{quantity}} kvůli nedostatečným zásobám.",
            "nonValidTotalPrice": "Z důvodu nízké hodnoty košíku nelze pokračovat.",
            "couponNotValid": "Kupon není validní, proto byl odstraněn."
        },
        "voucher": {
            "applyVoucherSuccess": "Kupón {{voucherCode}} byl uplatněn.",
            "removeVoucherSuccess": "Kupón {{voucherCode}} byl odstraněn."
        }
    },
    "savedCartList": {
        "savedCartList": {
            "swapCartNoActiveCart": "Košík \"{{cartName}}\" byl úspěšně obnoven.",
            "swapCartWithActiveCart": "Košík \"{{cartName}}\" byl úspěšně obnoven. Vaše předchozí položky byly uloženy do košíku {{previousCartName}}."
        }
    },
    "savedCartCartPage": {
        "savedCartCartPage": {
            "messages": {
                "cartSaved": "Položky vašeho košíku byly úspěšně uloženy na později do košíku \"{{cartName}}\""
            }
        }
    },
    "savedCart": {
        "savedCartDialog": {
            "id": "ID",
            "deleteCartSuccess": "Košík byl úspěšně smazán",
            "editCartSuccess": "Košík byl úspěšně uložen"
        }
    },
    "user": {
       "authMessages": {
          "signedOutSuccessfully": "Byli jste úspěšně odhlášeni.",
          "unrecoverableError": "Nelze zahájit přihlášení, prosím kontaktujte správce."
       }
    },
    "siko": {
        "siko": {
            "rateLimit": "Z vašeho zařízení evidujeme vyšší počet požadavků. Přístup na web SIKO je proto dočasně omezen.\nZkuste prosím stránky zavřít, chvíli počkat a poté to znovu zkusit.",
            "addedToCartWithReducedAmount": "Množství u položky: {{ product }} bylo sníženo z {{ quantity }} {{ unit }} na {{ addedQuantity }} {{ unit }} z důvodu nedostatočné zásoby na skladě",
            "totalPriceWithoutTax": "Celkem bez DPH",
            "addToCartAll": "Přidat do košíku vše",
            "freeGift": "Dárek zdarma",
            "reloadPage": "Obnovit stránku",
            "datatableOfQuantityRecords_one": "z {{count}} záznamu",
            "datatableOfQuantityRecords_few": "z {{count}} záznamů",
            "datatableOfQuantityRecords_other": "z {{count}} záznamů",
            "buy": "Koupit",
            "viewMode": "Rozložení:",
            "correctErrorsBelow": "Prosíme opravte chyby níže",
            "bonusGroup": "VO skupina",
            "importSavedCart": "Importovat uložený košík",
            "yes": "Ano",
            "cancel": "Zrušit",
            "count": "Množství",
            "contactSiko": "Kontakt SIKO",
            "contactHeading": "Kontakt",
            "storeDetail": "Detail prodejny",
            "backToStore": "Zpět do obchodu",
            "deleteCart": "Smazat košík",
            "continueInShopping": "Pokračovat v objednávce",
            "delivery": "Doručení",
            "allowPartialDelivery": "Částečné dodání",
            "withoutVat": "bez DPH",
            "total": "Celkem",
            "sikoPrice": "SIKO cena",
            "superPrice": "Super cena",
            "documents": "Přílohy",
            "withVat": "s DPH",
            "packaging": "Balení",
            "pricePerPackage": "Cena za balení",
            "yourPrice": "Vaše cena",
            "quantity": "Počet",
            "priceForEach": "Cena za každého",
            "price": "Cena",
            "priceMO": "MO Cena",
            "item": "Položka",
            "changePassword": "Změna hesla",
            "personalData": "Osobní údaje",
            "saveDate": "Uložit změnu",
            "removeOrderEntry": "Odebrat",
            "companyId": "IČO",
            "vatId": "DIČ",
            "businessVatId": "IČ DPH",
            "more": "Víc",
            "displayDocuments": "Zobrazit dokumenty",
            "order": "Objednávka",
            "sapOrder": "Zakázka",
            "orderPoNumber": "Vaše označení objednávky",
            "datePlaced": "Datum objednání",
            "orderPlacedBy": "Objednávka zadaná uživatelem",
            "orderStatus": "Stav objednávky",
            "totalPrice": "Celková cena",
            "shippingDetails": "Doručovací údaje",
            "shippingMethod": "Způsob dopravy",
            "billingDetails": "Fakturační údaje",
            "paymentType": "Platební metoda",
            "repeatPayment": "Opakovat platbu",
            "reorder": "Objednat znovu",
            "sapCodeTitle": "Číslo zakázky",
            "sapQuoteTitle": "Číslo nabídky",
            "select": "Zvolit",
            "discount": "Sleva",
            "shipping": "Doprava",
            "savedAmountMessage": "Na objednávce jste ušetřili {{savedAmount}}",
            "orderNote": "Poznámka k objednávce",
            "searchBoxPlaceHolder": "Zkuste napsat např. vana, dřez… (nebo zadejte hledaný výraz…)",
            "searchProduct": "Hledat produkt",
            "confirm": "Potvrdit",
            "myAccountTitle": "Můj účet",
            "technicalDraw": "Technický nákres",
            "drawing": "Nákres",
            "video": "Video",
            "downloadPdf": "Stáhnout (.PDF)",
            "emptyFilters": "Nebyly nalezeny žádné vhodné filtry.",
            "purchasableJustInOtherShopMessage": "Tento produkt lze zakoupit pouze na některé z prodejen",
            "pickUpInMyStore": "Vyzvednutí na prodejně",
            "deliverToAddress": "Zaslat na adresu",
            "pickUpAtAnotherStore": "Převzít na jiné prodejně",
            "storeDisponibility": "Dostupnost na prodejně",
            "eShopDisponibility": "Dostupnost z e-shopu",
            "inStock": "Skladem",
            "inCentralStock": "Skladem na centrále",
            "outOfStock": "Nedostupné",
            "saleEnded": "Prodej byl ukončen",
            "awaiting": "Na cestě",
            "except": "Očekáváme:",
            "onOrder": "Na objednávku",
            "days": "dní",
            "ourProductCode": "Náš kód zboží",
            "ean": "EAN",
            "onPredefinedPointOfService": "Na mé prodejně",
            "mark": "Značka",
            "originCountry": "Země původu",
            "statisticalNumber": "Statistické číslo zboží",
            "category": "Kategorie",
            "topSellingProducts": "Nejprodávanější",
            "displayNext": "Zobrazit další",
            "series": "Série",
            "brands": "Značky",
            "product": "Produkt",
            "products": "Produkty",
            "categories": "Kategorie",
            "articles": "Články",
            "stores": "Prodejny",
            "concept": "Koncept",
            "hide": "Skrýt",
            "filtering": "Filtr",
            "sorting": "Řazení",
            "moreAboutProduct": "Více o produktu",
            "showDetails": "Zobrazit detail",
            "showMore": "Zobrazit více",
            "showAllResults": "Zobrazit všechny výsledky",
            "fullOffer": "Celá nabídka",
            "continueToRead": "Pokračovat ve čtení",
            "countOfProducts_one": "{{count}} produkt",
            "countOfProducts_few": "{{count}} produkty",
            "countOfProducts_other": "{{count}} produktů",
            "sortingBy": "Řadit podle:",
            "proformInvoice": "Proforma faktura",
            "orderConfirmationMessage": "Potvrzení zakázky",
            "notAllowedAction": "Není možné provést tuto akci",
            "charactersLeft": "Zbývá znaků : {{count}}",
            "delete": "Smazat",
            "removedCart": "Váš košík byl úspěšně vymazán",
            "or": "nebo",
            "goToCart": "Přejít do košíku",
            "openDetail": "Otevřít detail",
            "searchStorePlaceHolder": "Zadejte město nebo PSČ",
            "selectNoItemsFound": "Nebyly nalezeny žádné výsledky",
            "updatePrice": "Aktualizovat cenu",
            "plpLoadMore": "Načíst další",
            "seenQuantityOfTotal_one": "Viděli jste {{quantity}} z {{count}} produktu.",
            "seenQuantityOfTotal_few": "Viděli jste {{quantity}} z {{count}} produktů.",
            "seenQuantityOfTotal_other": "Viděli jste {{quantity}} z {{count}} produktů.",
            "updateProfileDetails": "Chci upravit údaje",
            "contentPageTitle": "{{title}} | SIKO B2B",
            "selectCsvFile": "Vybrat .CSV soubor",
            "importOtherFile": "Vybrat jiný soubor",
            "weight": "Hmotnost",
            "free": "Zdarma",
            "deleteItem": "Odstranit položku",
            "checkoutPageTitle": "Zaplacení | SIKO B2B",
            "pickUpInStore": "Odběr na prodejně",
            "deliveryToAddress": "Doručení na adresu",
            "pickupPoints": "Výdejní místa",
            "addressOfShipment": "SIKO závoz na adresu",
            "cart": "Košík",
            "totalVAT": "DPH celkem",
            "subtotal": "Mezisoučet",
            "orderDiscounts": "Celková sleva",
            "orderTotal": "Celkem k úhradě",
            "notAddedDeliveryRestrictionMessage": "Omlouváme se, ale aktuálně neumožňujeme dopravu na adresu a vyzvednutí na prodejně ve stejné objednávce.",
            "phoneNumberPrefix": "Mobilní předvolba",
            "backToShop": "Zpět do eshopu",
            "insufficientAmount": "Nedostatečné zásoby na prodejně {{pointOfService}}",
            "importOrderEntries": "Importovat košík",
            "outOf": "z",
            "predefinedPOS": " (preferovaná)",
            "from": "od",
            "pickupPoint": "Výdejní místo",
            "unit": {
                "items": "ks"
            },
            "footer": {
                "numberOfStoresInSK": "v SK",
                "numberOfStoresInCZ": "v CZ",
                "needHelp": "Potřebujete pomoc?",
                "helpAssistanceMessage": "Přidělený zodpovědný pracovník Vám rád pomůže."
            },
            "myAccountSideMenu": {
                "purchases": "Nákupy",
                "account": "Účet"
            },
            "pickupInOtherStoreDialog": {
                "productAvailabilityByStore": "Dostupnost produktu na prodejnách",
                "searchPlaceholder": "Hledejte prodejny ve Vašem okolí (město, obec, PSČ):"
            },
            "showcaseDialog": {
                "productShowcaseInStore": "Seznam prodejen, na kterých je zboží vystavené"
            },
            "address": {
                "id": "IČO",
                "taxId": "DIČ",
                "vatIdCz": "DIČ",
                "vatIdOthers": "IČ DPH",
                "addressForm": {
                    "createAndSet": "Vytvořit a zvolit adresu"
                }
            },
            "productLabel": {
                "new": "Novinka",
                "sale": "Výprodej",
                "hit": "Hit"
            },
            "openingHours": {
                "title": "Otevírací doba",
                "currentlyOpen": "Aktuálně otevřeno",
                "currentlyClosed": "Aktuálně zavřeno",
                "closed": "Zavřeno",
                "forDay": "Otevírací doba pro",
                "openingHoursChanged": "Změněná otevírací doba"
            },
            "otherStoreDialog": {
                "onOrder": "Omlouváme se. Zboží na prodejně bohužel nemáme skladem, ale můžete si jej objednat.",
                "inStock": "Máme skladem. Chcete si zboží vyzvednout na vybrané prodejně?",
                "orderInStore": "Objednat na prodejnu",
                "addToCart": "Vložit do košíku",
                "searchHeading": "Vyhledávání prodejen"
            },
            "sellUnits": {
                "MBL": "Malé balení",
                "VBL": "Velké balení",
                "DBL": "Dodavatelské balení"
            },
            "pdpProductDialog": {
                "title": "Informace o produktu"
            },
            "payment": {
                "errorGeneral": "Nastala chyba pri zpracování požadavku",
                "error": "Platba skončila chybou",
                "pgnr": "Vaše platba nebyla zpracována z důvodu nedostupnosti platební brány",
                "sapOrderNotFound": "Tato zakázka nemůže být zaplacena"
            },
            "invoiceType": {
                "REGULAR": "Faktura",
                "DEPOSIT": "Zálohová faktura",
                "CREDIT": "Dobropis",
                "CREDIT_PRICE": "Cenový dobropis",
                "DEBIT_PRICE": "Cenový vrubopis",
                "CREDIT_BONUS": "Dobropis za bonus",
                "CANCELLATION": "Storno faktura",
                "DEPOSIT_CANCELLATION": "Storno zálohová faktura",
                "CREDIT_CANCELLATION": "Storno dobropis"
            },
            "deliveryNoteType": {
                "REGULAR": "Běžný dodací list",
                "RETURN": "Vratkový dodací list"
            },
            "orderConfirmation": {
                "thankYouMessage": "Děkujeme za Vaši objednávku",
                "processingOrderMessage": "Vaše objednávka se zpracovává.",
                "confirmOrderMessage": " Obratem obdržíte potvrzení s číslem zakázky.",
                "proformaMessage": "Zvolili jste si platbu: {{ paymentType }}. Proforma fakturu naleznete v detailu zakázky po jejím potvrzení.",
                "pendingMessage": "Vaše platba se zpracovává.",
                "paidMessage": "Vaše objednávka byla úspěšně zaplacena.",
                "cancelledMessage": "Vaše platba byla zrušena.",
                "emailMessage": "Kompletní informace o objednávce budou odeslány na e-mail ",
                "repeatPayment": "Opakovat platbu",
                "errorMessage": "Vaše platba skončila chybou.",
                "bonusProgramPoints": "{{count}} bonusových bodů je na cestě k Vám",
                "bonusProgramInfo": "Bonusové body se připíší na Váš účet hned po převzetí zboží. Za body lze získat slevu na vybraný sortiment."
            },
            "ticket": {
                "ticket": "Nesrovnalost",
                "ticketHistoryPageTitle": "Historie nesrovnalostí",
                "allDetails": "Všechny detaily",
                "product": "Produkt",
                "addData": "Doplnit údaje",
                "order": "Zakázka",
                "creationDate": "Datum nahlášení",
                "deliveryDate": "Datum odběru",
                "document": "Dodací list",
                "addedPhotos": "Přiložené fotografie",
                "yourNote": "Váš popis",
                "comments": "Vyjádření",
                "sendTicket": "Posunout ke zpracování",
                "notFound": "Nesrovnalost nenalezena",
                "creationError": "Nepodařilo se založit nesrovnalost",
                "status": {
                    "label": "Stav",
                    "customeraction": "Akce zákazníka",
                    "open": "Nové",
                    "inprocess": "Zpracovává se",
                    "conflict": "Spor",
                    "resolved": "Vybaveno",
                    "rejected": "Zamítnuto"
                },
                "reason": {
                    "label": "Důvod",
                    "complaint": "Stížnost/Reklamace",
                    "discrepancy": "Nesrovnalost",
                    "damaged": "Poškozeno",
                    "incorrect_amount": "Nesprávne množství",
                    "not_delivered": "Nedodáno",
                    "incorrect_product": "Záměna",
                    "incorrect_color_dimension": "Nesprávny odstín/rozměr",
                    "other": "Jiné"
                }
            },
            "facet": {
                "activeFilters_one": "{{count}} aktivní",
                "activeFilters_few": "{{count}} aktivní",
                "activeFilters_other": "{{count}} aktivních",
                "shownProducts_one": "{{count}} zobrazený produkt",
                "shownProducts_few": "{{count}} zobrazené produkty",
                "shownProducts_other": "{{count}} zobrazených produktů",
                "label": "Filtr",
                "notFound": "Hmm... Nic se nenašlo.",
                "cancelFacets": "Zrušit všechny filtry",
                "cancelFacetsShort": "Zrušit všechny",
                "showMoreFacets": "Dalších",
                "showResults": "Zobrazit výsledky",
                "updateFilters": "Upravit filtry",
                "typeSearchString": "Zadejte hledaný výraz",
                "activeList": "Aktivní filtry:"
            },
            "disponibility": {
                "inStock": "Skladem {{amount}} {{unit}}",
                "upcoming": "Na cestě",
                "upcomingWithDelivery": "Očekáváme {{date}}",
                "onOrder": "Na objednávku",
                "onOrderWithTime_one": "Běžná doba dodání {{count}} pracovní den",
                "onOrderWithTime_few": "Běžná doba dodání {{count}} pracovní dny",
                "onOrderWithTime_other": "Běžná doba dodání {{count}} pracovních dní",
                "outOfStock": "Není skladem"
            }
        }
    }
}
